import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  TextField,
  Button,
  Modal,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { BASE_URL } from "../../services/configUrls";

const Advannouncement = () => {
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [previewImg, setPreviewImg] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch images
  const fetchItems = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/documents/getimage`);
      setItems(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // Upload image
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select a file.");

    const formData = new FormData();
    formData.append("description", description);
    formData.append("file", file);

    try {
      setLoading(true);
      await axios.post(`${BASE_URL}/documents/uploadimage`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setDescription("");
      setFile(null);
      fetchItems();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Delete API
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/documents/deleteimage/${id}`);
      setItems((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      {/* Upload Form */}
      <Paper className="p-4 shadow-md space-y-4">
        <h2 className="text-xl font-semibold">Upload Image</h2>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col md:flex-row gap-4 items-start md:items-end"
        >
          <TextField
            label="Description"
            size="small"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          <Button variant="contained" component="label">
            Select Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Button>

          <Button variant="contained" type="submit" disabled={loading}>
            {loading ? "Uploading..." : "Upload"}
          </Button>
        </form>

        {file && (
          <p className="text-sm text-gray-600 mt-1">
            Selected: <span className="font-medium">{file.name}</span>
          </p>
        )}
      </Paper>

      {/* Images Table */}
      <Paper className="p-4 shadow-md">
        <h2 className="text-xl font-semibold mb-3">Images List</h2>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell><strong>Description</strong></TableCell>
              <TableCell><strong>Image</strong></TableCell>
              <TableCell align="right"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No images found
                </TableCell>
              </TableRow>
            ) : (
              items.map((item) => (
                <TableRow key={item.id} hover>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>{item.description}</TableCell>

                  <TableCell
                    className="text-blue-600 underline cursor-pointer"
                    onClick={() => setPreviewImg(item.file_path)}
                  >
                    View Image
                  </TableCell>

                  <TableCell align="right">
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => {
                        setDeleteId(item.id);
                        setOpenConfirm(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* Image Preview Modal */}
      <Modal open={!!previewImg} onClose={() => setPreviewImg(null)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 2,
            maxWidth: "90vw",
            maxHeight: "90vh",
            borderRadius: 2,
          }}
        >
          <img
            src={`${BASE_URL}/${previewImg}`}
            alt="Preview"
            className="w-full h-auto"
          />
        </Box>
      </Modal>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this image?</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleDelete(deleteId);
              setOpenConfirm(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Advannouncement;
